module.exports = __webpack_public_path__ + "img/arrow_right.5e5875d1.svg";